import { Outlet } from "react-router-dom";
import "../Layouts/Layout.scss";
import { formatUrl } from "../../utils/formatting";
import Modal from "../../components/popUps/Modal";
import { useState, useEffect } from "react";
import ActionIconContainer_Page from "../../components/UI/ActionIconContainer_Page";
import { useSelector, useDispatch } from "react-redux";
import Select_Input from "../../components/UI/Select_Input";
import { getRequest } from "../../apiService"; // 
import Info_Popup from "../../components/popUps/Info_Popup";

const Modal_pg = (props) => {
  let disclaimerAgreed = useSelector(
    (state) => state.disclaimerPopUp.disclaimerSigned
  );
  const [inputs, setInputs] = useState({});
  const [yearData, setYearData] = useState([]);

  useEffect(() => {
    document.title = props.title;
  }, [props.title]);

  useEffect(() => {
    initializeData();
  }, []);

  const initializeData = async () => {
    const result = await getRequest("type/getRequestedType/?id=36");
    
    if (result.success) {
      setYearData(result.data.data);
    } else {
      console.error("Failed to load Financial Year data:", result.error);
    }
  };

  function getTitleFromUrl() {
    const urlPath = window.location.pathname;
    console.log(urlPath);
    let title = formatUrl(urlPath);
    return title;
  }

  function checkDisclaimer() {
    console.groupCollapsed("disclaimer show");
    console.log("redux state disclaimer is: " + disclaimerAgreed);
    let show;
    if (disclaimerAgreed === true) {
      show = false;
    } else {
      show = true;
    }
    console.log("show disclaimer modal: " + show);
    console.groupEnd();
    return show;
  }

  function updateSelectFields(inputField, newValue) {
    setInputs((values) => ({ ...values, [inputField]: newValue }));
  }

  return (
    <div
      id={typeof props.id !== "undefined" ? "pg_" + props.id : ""}
      className="page-content-container-v2"
    >
      <h1 className="pg-title">
        {typeof props.title !== "undefined" ? props.title : getTitleFromUrl()}
      </h1>
      {typeof props.title !== "undefined" &&
        props.title === "E-Strat Calculator" &&
        yearData.length > 0 && (
          <Select_Input
            data={yearData}
            defaultTxt="Year"
            desc="Financial Year Select"
            defaultValue="0"
            optionSelectedOnLoad={2476}
            defaultSelectable={false}
            inputName={"financial-year-select"}
            id={"financial-year-select"}
            optionId={"id"}
            optionValue={"name"}
            newStructureOptions={false}
            updateSelectChange={updateSelectFields}
            classes={"select-pg-outsideModal"}
          />
      //     <Select_dropdown
      //   data={yearData}
      //   id={"financial-year-select"}
      //   defaultTxt_onLoad="FY filter"
      //   hoverDesc="Financial Year Select"
      //   defaultValue_onLoad="default"
      //   optionSelectedOnLoad={2301}
      //   defaultSelectable={false}
      //   inputName={"financial-year-select"}
      //   disabled={false}
      //   optionVal_key={"id"}
      //   optionTxt_key={"name"}
      //   updateMethod={updateSelectFields}
      //   classes={"external_dropdownSelect"}
      // />
        )}
      {typeof props.ActionBar !== "undefined" && props.ActionBar.length > 0 && (
        <ActionIconContainer_Page
          orientation="horizontal"
          showOnMobile={false}
          id={"edit-data-field"}
          data={[
            {
              id: "back",
              icon: "undo",
              method: "navBack",
              hoverDesc: "Back",
            },
          ]}
        />
      )}
      {props.title === "E-Strat Calculator" && 
      <>
{/* <ActionIconContainer_Page
          orientation="horizontal"
          showOnMobile={true}
          id={"show-calc-details"}
          data={[
            {
              id: "info",
              icon: "info",
              method: "toggle_grid",
              hoverDesc: "Calc Details",
            },
          ]}
        /> */}
        {/* Building a Admin priveleged popup with edit capability for copy and content */}
          <Info_Popup />
        </>
}
      {props.title === "E-Strat Calculator" && checkDisclaimer() && <Modal />}
      <div
        className={
          props.Align_vert === "Center"
            ? "pageContent-center-v2"
            : "pageContent-center-v2 align-top"
        }
      >
        <div
          className={
            props.Align_vert === "Center"
              ? "modal-white modal-content-center"
              : "modal-white modal-content-top"
          }
        >
          <Outlet />
        </div>

        <div className="bufferBox-xs"></div>
      </div>
      {/* {props.title === "My Reports" &&
      <ScreenSizeWarning id={props.id} pg={props.title} classes={""} maxSize={"600px"} message={"Content requires minimum screen size of 600px. Rotate screen to view"} icon={"screen_rotation"}/>
      } */}
      </div>
  );
};
export default Modal_pg;